controllers.controller('PendingDepositController', [
    '$scope', '$state', 'UserService', 'ErrorService', 'constants', 'LocaleService', 'Storage', 'API', '$ionicLoading',
    function ($scope, $state, UserService, ErrorService, Const,  LocaleService, Storage, API, $ionicLoading) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.method = $state.params.method || '';
        $scope.depositValue = Storage.get('depositValue');
        $scope.pspCurrencies = $scope.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.showAmountSelect = true;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };

        var user = UserService.get();
        $scope.pendingDepositMessage = $scope.translation['pendingDepositMessage'].replace('${clientName}', [user.firstName, user.lastName].join(' '))
            || 'Please contact support';

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.onDeposit = function(){
            $ionicLoading.show()
            var request = {
                type: 'Deposit',
                amount: $scope.amount.value,
                paymentMethod: $scope.translation[$scope.method.name] || $scope.method.name
            };

            return API.pendingDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.pending;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = $scope.pendingDepositMessage;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide()
                    $scope.showMessage = true;
                    $scope.modal.textTitle = LocaleService.translation.messages.pending;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = $scope.pendingDepositMessage;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'HostedPageController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if($scope.method.hasOwnProperty("amountRequired") && !$scope.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
            }
        });
    }]);
